import { Navigate, useParams, useSearchParams } from "react-router-dom";

export function SkillRun() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return (
    <Navigate
      to={`/migrations/${encodeURIComponent(id ?? "")}${qs ? `?${qs}` : ""}`}
      replace
    />
  );
}
